import { OrderV2 } from '@kotipizzagroup/kotipizza-orders-api-client';
import { StyledPaper, TitleRow } from '../../Styled/Styled';
import { CustomerDetailsContainer, FieldGrid, FieldLabel, FieldValue } from './Styled';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { isOrderPaid } from '../../utils/orderUtils';
import { DELIVERY_TYPES } from '../constants';

export const OrderEstimates: React.FC<{ order: OrderV2 }> = ({ order }) => {
  const { t } = useTranslation();
  const isDelivery = order.deliveryType === DELIVERY_TYPES.delivery;
  const webShopEstimate = isDelivery ? order.deliveryEstimate : order.pickupEstimate;
  const restaurantEstimate = order.AcceptanceEstimate;

  const actualProcessTime = isOrderPaid(order)
    ? //Calculate the difference between timestamps to milliseconds, transform them to Minutes and round up to remove decimals
      order.s4dOrderId !== null
      ? Math.round(
          dayjs(
            isDelivery
              ? order.s4dDeliveryCompleteTimestamp
              : order.ReadyForDispatch ?? order.s4dDeliveryCompleteTimestamp
          ).diff(order.orderPaid) / 60000
        )
      : order.ProcessFinished
      ? Math.round(dayjs(order.ProcessFinished).diff(order.orderPaid) / 60000)
      : null
    : null;

  return (
    <StyledPaper variant="outlined">
      <CustomerDetailsContainer>
        <TitleRow>
          <h3>{t('Time estimates')}</h3>
        </TitleRow>
        <FieldGrid>
          <FieldLabel>{t('orderDetails.webshopEstimate')}</FieldLabel>
          {/* eslint-disable-next-line i18next/no-literal-string */}
          <FieldValue>{webShopEstimate ?? '~'} min</FieldValue>

          <FieldLabel>{t('orderDetails.restaurantEstimate')}</FieldLabel>
          {/* eslint-disable-next-line i18next/no-literal-string */}
          <FieldValue>{restaurantEstimate ?? '~'} min</FieldValue>

          <FieldLabel>{t('orderDetails.actualProcessTime')}</FieldLabel>
          {/* eslint-disable-next-line i18next/no-literal-string */}
          <FieldValue>{actualProcessTime ?? '~'} min</FieldValue>
        </FieldGrid>
      </CustomerDetailsContainer>
    </StyledPaper>
  );
};
